import { render } from "./RevenueGoals.vue?vue&type=template&id=06e998d0"
import script from "./RevenueGoals.vue?vue&type=script&lang=js"
export * from "./RevenueGoals.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__